import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  DataGrid,
  ruRU,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@material-ui/data-grid";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Select } from "../../components/tools/SelectorOrText/Select";
import ArrowBackIcon from "@material-ui/icons/ArrowBack.js";

import {
  selectCompany,
  setSelectedCompanies,
} from "../../redux/reducers/chart-reducer";

import { useRedirect } from "../../hooks/useRedirect";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import { RouteNames } from "../../router/consts";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  selectOption: {
    backgroundColor: theme.palette.common.white,
    width: 175,
  },
  selectOutlined: {
    padding: "8.5px 35px 8.5px 10px",
  },
}));

const CustomToolbar = (chartDetail, contractorName) => {
  const classes = useStyles();
  const { companies, selectedCompany } = useSelector(selectCompany);

  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.setItem('companies', companies[0].name)
  }, [companies])

  const handleCompanySelector = (e) => {
    localStorage.setItem('companies', companies.filter((f) => f.id === e.target.value)[0].name)
    dispatch(
      setSelectedCompanies(companies.filter((f) => f.id === e.target.value)[0])
    );
  };

  const { redirect } = useRedirect();
  let { chartId } = useParams();
  const onPaste = async (e) => {
    redirect(RouteNames.CHART_PAGE);
  };

  return (
    <GridToolbarContainer>
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item>
          {chartId ? (
            <Button onClick={onPaste}>
              <ArrowBackIcon fontSize="small" />
            </Button>
          ) : null}

          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
        </Grid>
      </Grid>

      <Grid item container alignItems={"center"} justifyContent={"flex-end"}>
        <Grid item>
          {chartDetail ? null : (
            <Select
              data={companies}
              formControlProps={{ variant: "outlined" }}
              selectProps={{
                className: classes.selectOption,
                classes: {
                  outlined: classes.selectOutlined,
                },
              }}
              uniqueKey={"chart-"}
              value={selectedCompany?.id}
              onChange={handleCompanySelector}
            />
          )}
          {contractorName ? (
            <span style={{ paddingRight: "20px" }}>
              <b>{contractorName}</b>
            </span>
          ) : null}
        </Grid>
      </Grid>
    </GridToolbarContainer>
  );
};

export const ChartTable = ({ data, columns, chartDetail, contractorName }) => {

  const { redirect } = useRedirect();

  const location = useLocation()
  
  const onChartClick = async (e) => {
    
    const chartId = e.row.id 
    const name = e.row.name
    const pathName = location.pathname === '/kpi' ? RouteNames.CHART_DETAIL : RouteNames.CHART_DEEP_ANALITICS;


    if (pathName === RouteNames.CHART_DETAIL) {
      localStorage.setItem('contractName', name)
      redirect(pathName, { chartId });
    } else {
      redirect(pathName, { chartId : location.pathname.slice(5), name });
    }
    
  };

  return (
    <Paper style={{ height: "100%", width: "100%" }}>
      <DataGrid
        rows={data ? data.map((el, index) => ({ ...el, sequenceNumber: index + 1 })) : []}
        columns={columns}
        components={{
          Toolbar: () => CustomToolbar(chartDetail, contractorName),
        }}
        onRowClick={onChartClick}
        density={"standart"}
        localeText={
          ruRU?.props?.MuiDataGrid?.localeText ||
          ruRU?.components?.MuiDataGrid?.defaultProps?.localeText
        }
        disableSelectionOnClick
        disableColumnMenu
        cell--textRight
      />
    </Paper>
  );
};